// adroll-boot.js — G4: AdRoll (NextRoll) pixel (classic script in <head>). The old Index.cshtml
// inline snippet, ported: the same globals (adroll_adv_id / adroll_pix_id / adroll_version), the
// same queued-method stub, roundtrip.js, and one "pageView". Ids come from data-*.
(function (w, d) {
  var me = d.currentScript;
  if (!me) return;
  var adv = me.getAttribute('data-adv-id');
  var pix = me.getAttribute('data-pix-id');
  if (!adv || !pix) return;

  w.adroll_adv_id = adv;
  w.adroll_pix_id = pix;
  w.adroll_version = '2.0';
  w.adroll_tag_source = w.adroll_tag_source || 'manual';
  w.__adroll_loaded = true;
  w.adroll = w.adroll || [];
  w.adroll.f = ['setProperties', 'identify', 'track', 'identify_email', 'get_cookie'];
  for (var a = 0; a < w.adroll.f.length; a++) {
    w.adroll[w.adroll.f[a]] = w.adroll[w.adroll.f[a]] || (function (n) {
      return function () { w.adroll.push([n, arguments]); };
    })(w.adroll.f[a]);
  }

  var e = d.createElement('script');
  e.async = 1;
  e.src = 'https://s.adroll.com/j/' + encodeURIComponent(adv) + '/roundtrip.js';
  var o = d.getElementsByTagName('script')[0];
  o.parentNode.insertBefore(e, o);
  w.adroll.track('pageView');
})(window, document);
